// Query parameters that must never reach a log, Honeybadger or analytics.
// `k` is the lineage access token printed inside the QR of a signed document
// (public route /d/:ulid?k=...): whoever holds it can read the document record.
const SECRET_QUERY_PARAMS = ['k'];

const REDACTED = 'REDACTED';

// Replaces the value of every secret query parameter with a placeholder and
// leaves the rest of the URL untouched. Works on absolute and relative URLs,
// and returns the input unchanged when it carries no query string.
export function redactUrlSecrets(url: string): string {
	const queryStart = url.indexOf('?');
	if (queryStart === -1) {
		return url;
	}

	const hashStart = url.indexOf('#', queryStart);
	const query = url.slice(
		queryStart + 1,
		hashStart === -1 ? undefined : hashStart,
	);
	const rest = hashStart === -1 ? '' : url.slice(hashStart);

	const redactedQuery = query
		.split('&')
		.map((pair) => {
			const name = pair.split('=')[0];
			return SECRET_QUERY_PARAMS.includes(decodeURIComponent(name))
				? `${name}=${REDACTED}`
				: pair;
		})
		.join('&');

	return `${url.slice(0, queryStart)}?${redactedQuery}${rest}`;
}
